export const workshops = [
  {
    key: 23,
    code: "dsa",
    title: "BlindCode 3.0",
    dateTime: "22nd September, 2026 | 3:00 PM - 5:00 PM" ,
    venue: "F-Block Library",
    category: "Coding | DSA",
    details: `The only coding event where looking at your code is cheating. Think fast, type faster, and trust your logic. Participants will solve DSA problems without seeing their screens, testing their logic, accuracy, and coding muscle memory.`,
    images: [
      require("../assets/worskshop-section/blindCode/blindcode3.jpeg"),
    ]
  },

  {
    key: 22,
    code: "dsp",
    title: "Distinguished Speaker Program",
    dateTime: "5th March, 2026 | 1:30 PM - 2:30 PM",
    venue: "Online Webinar",
    category: "AI | Web Technologies",
    details: `🧠 ACM Society presents: "There is No I in AI"
🎙️ Speaker: Steven Pemberton, a distinguished computer scientist from Amsterdam and active member of the World Wide Web Consortium.
💡 What you'll gain: Insights on collaborative AI, the future of intelligent systems, and perspectives on AI & web technologies.`,
    images: [
      require("../assets/worskshop-section/DSP26/dsp.jpeg"),
    ]
  },

  {
    key: 21,
    code: "dsa",
    title: "Codejam Talks",
    dateTime: "9th October, 2025 | 10:00 AM - 3:00 PM",
    venue: "Room No. A405",
    category: "Coding | DSA | Innovation",
    details: `CodeGem Talks turned out to be an electrifying blend of code, conversation, and creativity. From intense coding challenges and DSA face-offs to engaging discussions, the event was packed with learning, competition, and inspiration. It was a day where ideas flowed, skills were tested, and passionate coders came together to share stories, spark innovation, and celebrate the spirit of technology.`,
    images: [
      require("../assets/worskshop-section/CodejamTalks/codejam_talks.jpeg"),
    ]
  },

  {
    key: 20,
    code: "dsa",
    title: "Mission Malamal",
    dateTime: "8th October | 10:00 AM",
    venue: "B-403",
    category: "Innovation | Creativity",
    details: `Mission Manamal delivered a power-packed showcase of bold ideas, fearless thinking, and unstoppable creativity. From fashion and AI to green tech, sustainability, and real-world problem solving, participants owned the stage with innovative solutions and fresh perspectives.`,
    images: [
      require("../assets/worskshop-section/Mission_Malamal/mission_malamal.jpeg"),
    ]
  },

  {
    key: 19,
    code: "dsa",
    title: "Blind Code 2.0",
    dateTime: "11th September | 3:00 PM - 5:00 PM",
    venue: "A-401",
    category: "Coding | DSA",
    details: `The ACM-BVP Society brought back one of our most thrilling challenges — BlindCode 2.0! 🖥️✨ Participants tackled programming problems with their screens completely covered, testing not just coding skills but also logic, precision, and confidence under pressure. This unique twist on traditional coding made the event intense, unforgettable, and a true test of going beyond the ordinary!`,
    images: [
      require("../assets/worskshop-section/blindCode/blind_code.png"),
    ]
  },

  {
    key: 18,
    code: "dsa",
    title: "Battle of Coders",
    dateTime: "8th April",
    venue: "A405 Lab",
    category: "Coding | DSA",
    details: `Battle of Coders was a high-energy competitive coding event designed to challenge participants with Data Structures and Algorithms (DSA) problems under time pressure. Participants competed head-to-head in an intense and intellectually stimulating environment.`,
    images: [
      require("../assets/worskshop-section/battleOfCoders/1.png"),
    ]
  },

  {
    key: 17,
    code: "ml",
    title: "Distinguished Speaker Program",
    dateTime: "1st April, 2025 | 1:00 PM",
    venue: "Online Webinar",
    category: "Cybersecurity | 5G | 6G",
    details: `Cybersecurity for 5g and 6g Technologies 🤖 - Webinar by distinguished Speaker Nicolas Skalov!🚀`,
    images: [
      require("../assets/worskshop-section/DSP25/1.jpg"),
    ]
  },

  {
    key: 16,
    code: "ml",
    title: "Hour Of Code",
    dateTime: "24th January | 11:00 AM - 12:00 PM",
    venue: "Govt. Sarvodaya Bal Vidyalaya",
    category: "Coding | Education",
    details: `ACM BVCOE transformed the Hour of Code into a memorable event for students, blending playtime with AI education. Their laughter and enthusiasm were truly inspiring, showcasing the fun side of learning about AI! 🎮🤖 #acm #hourofcode #aieducation #stemlearning`,
    images: [
      require("../assets/worskshop-section/HourOfCode25/1.jpg"),
    ]
  },

  {
    key: 15,
    code: "ml",
    title: "Ai-Fundamental Workshop",
    dateTime: "17th November, 2024 | 3:00 PM - 4:00 PM",
    venue: "",
    category: "AI | Workshop",
    details: `Ai FUndamentals 🤖 - Webinar by Professor Dr. Ravi Prakash!🚀`,
    images: [
      require("../assets/worskshop-section/AiWorkshop25/1.jpg"),
    ]
  },

  {
    key: 14,
    code: "dsa",
    title: "Code Showdown",
    dateTime: "",
    venue: "",
    category: "Coding | DSA",
    details: `ACM BVCOE brought the excitement of coding to life with Code Showdown! 💻✨ This 3-round DSA event challenged participants to push their problem-solving skills to the max, fostering teamwork and innovation along the way. The energy and passion of the students were contagious, proving that learning DSA can be both thrilling and rewarding!`,
    images: [
      require("../assets/worskshop-section/codeShowdown/1.png"),
    ]
  },

  {
    key: 13,
    code: "dsa",
    title: "Blind Code",
    details: `The ACM-BVP Society hosted an exciting event, BlindCode, designed to test coding enthusiasts skills like never before! 🖥️💡 Participants faced the ultimate challenge: solving coding problems with their screens entirely covered. The event highlighted problem-solving under pressure and added a unique twist to traditional coding, showcasing just how much our members love to push the limits!`,
    images: [
      require("../assets/worskshop-section/blindCode/1.png"),
      require("../assets/worskshop-section/blindCode/2.png"),
      require("../assets/worskshop-section/blindCode/3.png")
    ]
  },

  {
    key: 12,
    code: "ml",
    title: "Hour Of Code",
    details: `ACM BVCOE transformed the Hour of Code into a memorable event for students, blending playtime with AI education. Their laughter and enthusiasm were truly inspiring, showcasing the fun side of learning about AI! 🎮🤖 #acm #hourofcode #aieducation #stemlearning`,
    images: [
      require("../assets/worskshop-section/HourOfCode/4.png"),
      require("../assets/worskshop-section/HourOfCode/5.png"),
      require("../assets/worskshop-section/HourOfCode/6.png")
    ]
  },

  {
    key: 11,
    code: "ml",
    title: "Distinguished Speaker Program",
    dateTime: "30th March, 2024",
    venue: "",
    category: "AI | Responsible AI",
    details: `Responsible AI 🤖 - Webinar by distinguished Speaker Ricardo Baeza-Yates!🚀`,
    images: [
      require("../assets/worskshop-section/DSP/1.png"),
      require("../assets/worskshop-section/DSP/2.png"),
      require("../assets/worskshop-section/DSP/3.png"),
    ]
  },

  {
    key: 10,
    code: "ml",
    title: "Design Dazzle",
    dateTime: "",
    venue: "",
    category: "Design | Creativity",
    details: `Reminiscing on the captivating energy of our Dazzle Design Technical Event! 🎨 From mesmerizing presentations to hands-on workshops, it was a day filled with inspiration and discovery.✨✨ Cheers to all the designers and tech enthusiasts who made it unforgettable!✌️`,
    images: [
      require("../assets/worskshop-section/deisgnDazzle/1.png"),
      require("../assets/worskshop-section/deisgnDazzle/aftertop1.png"),
      require("../assets/worskshop-section/deisgnDazzle/aftertop2.png"),
      require("../assets/worskshop-section/deisgnDazzle/top.png"),
    ]
  },

  {
    key: 9,
    code: "ml",
    title: "GEEKOUT 2.0",
    details: `Geekout 2.0 BVEST'24 Technical Event!🚀 Flashback to the thrill of our Geekout Technical Fest! 🚀 We're still buzzing with excitement from all the incredible tech demos, insightful discussions, and connections made.✨✨ A big shoutout to our amazing speakers, sponsors, and attendees for making this event one to remember. Here's to the next geeking out adventure!✨✨.`,
    images: [
      require("../assets/worskshop-section/Geekout/aftertop1.png"),
      require("../assets/worskshop-section/Geekout/aftertop2.png"),
      require("../assets/worskshop-section/Geekout/highlight.png"),
      require("../assets/worskshop-section/Geekout/top.png"),
    ]
  },

  {
    key: 8,
    code: "ml",
    title: "ACM FIESTA",
    details: `ACM BVP hosted an event that’s not just entertaining but also full of energy! 🥳✨`,
    images: [
      require("../assets/worskshop-section/fiesta/4.png"),
      require("../assets/worskshop-section/fiesta/5.png"),
      require("../assets/worskshop-section/fiesta/6.png"),
    ]
  },

  {
    key: 5,
    code: "ar",
    title: "AUGMENTED REALITY",
    details: `ACM-W BVP presented a hands-on session on Augmented Reality for students of various colleges across all branches. The students were taught AR right from beginning to building a complete AR project. The session received an overwhelming response from students of various colleges.`,
    images: [
      require("../assets/gallery/ar/ar1.jpg"),
      require("../assets/gallery/ar/ar2.jpg"),
      require("../assets/gallery/ar/ar3.jpg"),
      require("../assets/gallery/ar/ar4.jpg"),
      require("../assets/gallery/ar/ar5.jpg")
    ]
  },

  {
    key: 4,
    code: "android",
    title: "ANDROID DEVELOPMENT",
    details: `Two sessions on ANDROID DEVELOPMENT was an interactive one! The students learned how to implement various layouts, add different views and viewgroups, and make an app interactive by adding onClick method.`,
    images: [
      require("../assets/gallery/android/android1.jpg"),
      require("../assets/gallery/android/android2.jpg"),
      require("../assets/gallery/android/android3.jpg"),
      require("../assets/gallery/android/android4.jpg"),
      require("../assets/gallery/android/android5.jpg"),
      require("../assets/gallery/android/android6.jpg")
    ]
  },

  {
    key: 3,
    code: "hs",
    title: "SESSION ON HIGHER STUDIES",
    details: `An amazing seminar in collaboration with Made Easy (IES-MADE EASY) by SUNEEL TIWARI Sir. The session gave students insights on career options available to them after college, and how to crack exams like GATE, IES & PSU in very first attempt.`,
    images: [
      require("../assets/gallery/hs/hs1.jpg"),
      require("../assets/gallery/hs/hs2.jpg"),
      require("../assets/gallery/hs/hs3.jpg"),
      require("../assets/gallery/hs/hs4.jpg")
    ]
  },

  {
    key: 2,
    code: "webDev",
    title: "WEB DEVELOPMENT",
    details: `Four sessions on JavaScript was conducted and attendees understood the core concepts of JavaScript and practical implementation of it.`,
    images: [
      require("../assets/gallery/webDev/webd1.jpg"),
      require("../assets/gallery/webDev/webd2.jpg"),
      require("../assets/gallery/webDev/webd3.jpg"),
      require("../assets/gallery/webDev/webd4.jpg"),
      require("../assets/gallery/webDev/webd5.jpg"),
      require("../assets/gallery/webDev/webd6.jpg"),
      require("../assets/gallery/webDev/webd7.jpg")
    ]
  },

  {
    key: 1,
    code: "hoc",
    title: "HOUR OF CODE",
    details: `ACM team was teaching the students of 5th standard the basics of programming and logic building, and quite surprising to see how quickly they were able to grasp the concepts.`,
    images: [
      require("../assets/gallery/hoc/hoc1.jpg"),
      require("../assets/gallery/hoc/hoc2.jpg"),
      require("../assets/gallery/hoc/hoc3.jpg"),
      require("../assets/gallery/hoc/hoc4.jpg"),
      require("../assets/gallery/hoc/hoc5.jpg"),
      require("../assets/gallery/hoc/hoc6.jpg"),
      require("../assets/gallery/hoc/hoc7.jpg")
    ]
  }
];